import {
  Component,
  ElementRef,
  HostListener,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import moment from "moment";
import { AuthService } from "../../app/auth/auth.service";
import { Prn } from "../../models/prn-model/prn-model";
import { PrnService } from "../../providers/prn-service/prn-service";
import { WebSocketService } from "../../providers/prn-service/socket";

@Component({
  selector: "prn-count",
  templateUrl: "./prn-count.html",
})
export class PrnCountComponent implements OnInit, OnDestroy, OnChanges {
  @Input() patientId: number;
  isDropdownOpen = false;
  prnData: Prn[] = [];
  loading: boolean = false;
  hasMinimum: boolean = false;
  ws: any;

  constructor(
    private authService: AuthService,
    private prnService: PrnService,
    private webSocketService: WebSocketService,
    private elementRef: ElementRef
  ) {}

  @HostListener("document:click", ["$event"])
  onDocumentClick(event: Event): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.isDropdownOpen = false;
    }
  }

  ngOnInit() {
    /*
     * Example how to connect to AppSync using websocket
     * and subscribe to a namespace/channel to listen
     * */
    /*this.webSocketService.connect({
                apiKey: "",
                realtimeHost: "",
                host: ""
            },
            (message) => {
                this.fetchPrnData();
            })
            .then((socket) => {
                this.webSocketService.subscribe("pedroTest", this.patientId.toString());
            }).catch((error) => {
            console.error(error);
        });*/

    if (this.patientId) {
      this.fetchPrnData();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      this.patientId &&
      changes["patientId"] &&
      !changes["patientId"].isFirstChange()
    ) {
      this.fetchPrnData();
    }
  }

  ngOnDestroy() {
    //this.webSocketService.disconnect();
  }

  fetchPrnData() {
    this.loading = true;
    const date: string = moment.utc(moment(), "YYYY-MM-DD HH:mm").format();
    setTimeout(() => {
      this.prnService.getPrnData(this.patientId, date).subscribe({
        next: (data) => {
          this.prnData = [];
          this.hasMinimum = false;
          if (data) {
            this.prnData = data.sort((a, b) =>
              a.discipline.localeCompare(b.discipline)
            );
            this.hasMinimum = this.prnData.every((prn) => prn.prnCount >= 2);
          }
          this.loading = false;
        },
        error: () => {
          this.prnData = [];
          this.loading = false;
        },
      });
    }, 1500);
  }

  toggleDropdown(): void {
    if (!this.loading) {
      this.isDropdownOpen = !this.isDropdownOpen;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/prn-count/prn-count.ts